const getElmtPos = (selector) => document.querySelector(selector).offsetTop - document.querySelector('#header').offsetTop;

export default getElmtPos;